import { useState } from "react";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import ImportCandidateModal from "@/components/import-candidate-modal";

import JobHeader from "./components/job-header";
import Brief from "./brief";
import Candidates from "./candidates";
import Pool from "./pool";
import Hunt from "./hunt";
import Ad from "./ad";
import Screening from "./screening";
import Interview from "./interview";
import StageRouter from "./stage";
import StageView from "./stage/view";
import PostDetail from "./post-detail";
import Stats from "./stats";
import RawData from "./raw-data";

export default function JobLayout({ job, setJob, posts, setPosts }) {
  const { id } = useParams();
  const location = useLocation();
  const [showImportModal, setShowImportModal] = useState(false);
  const [refreshCandidates, setRefreshCandidates] = useState(0);

  const defaultElement = <Candidates job={job} setJob={setJob} refreshTrigger={refreshCandidates} posts={posts} />;

  const isContentFlex = location.pathname.endsWith("/candidates") || location.pathname === `/recruiter/job-ads/${id}` || location.pathname.includes("/ad");

  return (
    <div className="w-full flex flex-col h-[calc(100vh-64px)]">
      <JobHeader job={job} setJob={setJob} posts={posts} setShowImportModal={setShowImportModal} />

      <div className={isContentFlex ? "flex-1 overflow-hidden" : "flex-1 overflow-auto"}>
        <Routes>
          <Route index element={defaultElement} />
          <Route path="candidates" element={<Candidates job={job} setJob={setJob} refreshTrigger={refreshCandidates} posts={posts} />} />
          <Route path="pipeline/*" element={<StageRouter job={job} setJob={setJob} />} />
          <Route path="brief" element={<Brief job={job} setJob={setJob} />} />
          <Route path="pool" element={<Pool job={job} setJob={setJob} />} />
          <Route path="hunt" element={<Hunt job={job} />} />
          <Route path="ad/*" element={<Ad job={job} setJob={setJob} posts={posts} setPosts={setPosts} />} />
          <Route path="screening" element={<Screening job={job} setJob={setJob} />} />
          <Route path="interview" element={<Interview job={job} setJob={setJob} />} />
          <Route path="stages/:stageId" element={<StageView job={job} setJob={setJob} />} />
          <Route path="post/:postId" element={<PostDetail />} />
          <Route path="stats" element={<Stats job={job} />} />
          <Route path="raw-data" element={<RawData job={job} />} />
        </Routes>
      </div>

      <ImportCandidateModal
        isOpen={showImportModal}
        onClose={() => setShowImportModal(false)}
        jobId={id}
        jobTitle={job?.title}
        onSuccess={() => setRefreshCandidates((prev) => prev + 1)}
      />
    </div>
  );
}
